import React, { Fragment, useMemo } from 'react';
import cn from 'classnames';
import overrideStyles from '@platform-ui/overrideStyles';
import baseStyles from './InlinePlaceholder.module.css';
const InlinePlaceholder = ({
  input,
  value: _value = '',
  placeholder,
  partialPlaceholder,
  isPlaceholderVisible,
  minWidth,
  dataQaType: _dataQaType = 'uikit/inlinePlaceholder',
  prefix,
  __overrideStyles,
  whiteSpace: _whiteSpace = 'nowrap',
  withBaseStyles: _withBaseStyles = false,
  mobile
}) => {
  const maskPart = partialPlaceholder && placeholder && typeof placeholder === 'string' && placeholder.substring(_value.length);
  const styles = useMemo(() => overrideStyles(baseStyles, __overrideStyles == null ? void 0 : __overrideStyles.InlinePlaceholder), [__overrideStyles]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn({
      [styles.root]: true,
      [styles.root_showPlaceholder]: !_value || partialPlaceholder
    }),
    style: {
      minWidth,
      whiteSpace: _whiteSpace
    },
    "data-qa-type": _dataQaType,
    "data-qa-placeholder-visible": isPlaceholderVisible && (!partialPlaceholder && !!placeholder || partialPlaceholder && !!maskPart)
  }, /*#__PURE__*/React.createElement("div", {
    "data-qa-type": `${_dataQaType}.wrapper`,
    className: cn(styles.placeholder, {
      [styles.placeholder_withBaseStyles]: _withBaseStyles,
      [styles.placeholder_mobile]: mobile
    }),
    role: "presentation",
    "aria-hidden": "true"
  }, prefix && /*#__PURE__*/React.createElement("span", {
    className: styles.placeholderPrefix
  }, `${prefix}\u200B`), partialPlaceholder ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${_dataQaType}.placeholderValue`,
    className: styles.placeholderValue
  }, _value), /*#__PURE__*/React.createElement("span", {
    "data-qa-type": `${_dataQaType}.placeholderMask`
  }, maskPart)) : /*#__PURE__*/React.createElement("span", null, placeholder)), /*#__PURE__*/React.createElement("div", null, input));
};
export default InlinePlaceholder;